import UsersAPI from '../api/users'
import StationAPI from '../api/station'

const CREATING_USER = 'CREATING_USER'
const CREATING_USER_SUCCESS = 'CREATING_USER_SUCCESS'
const CREATING_USER_ERROR = 'CREATING_USER_ERROR'
const FETCHING_USERS = 'FETCHING_USERS'
const FETCHING_USERS_SUCCESS = 'FETCHING_USERS_SUCCESS'
const FETCHING_USERS_ERROR = 'FETCHING_USERS_ERROR'
const FETCHING_USER = 'FETCHING_USER'
const FETCHING_USER_SUCCESS = 'FETCHING_USER_SUCCESS'
const FETCHING_USER_ERROR = 'FETCHING_USER_ERROR'
const UNSET_USER = 'UNSET_USER'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    error: null,
    users: [],
    stations: {},
    currentUser: null,
    currentUserError: null,
    currentUserLoading: false
  },
  getters: {
    isLoading (state) {
      return state.isLoading
    },
    hasError (state) {
      return state.error !== null
    },
    error (state) {
      return state.error
    },
    hasUsers (state) {
      return state.users.length > 0
    },
    users (state) {
      return state.users
    },
    stations (state) {
      return state.stations
    },
    hasUser (state) {
      return state.currentUser !== null
    },
    user (state) {
      return state.currentUser
    }
  },
  mutations: {
    [CREATING_USER] (state) {
      state.isLoading = true
      state.error = null
    },
    [CREATING_USER_SUCCESS] (state, user) {
      state.isLoading = false
      state.error = null
      state.users.unshift(user)
    },
    [CREATING_USER_ERROR] (state, error) {
      state.isLoading = false
      state.error = error
      state.users = []
    },
    [FETCHING_USERS] (state) {
      state.isLoading = true
      state.error = null
      state.users = []
      state.stations = {}
    },
    [FETCHING_USERS_SUCCESS] (state, payload) {
      state.isLoading = false
      state.error = null
      state.users = payload.users
      state.stations = payload.stations
    },
    [FETCHING_USERS_ERROR] (state, error) {
      state.isLoading = false
      state.error = error
      state.users = []
      state.stations = []
    },
    [FETCHING_USER] (state) {
      state.currentUserLoading = true
      state.currentUserError = null
      state.currentUser = null
    },
    [FETCHING_USER_SUCCESS] (state, user) {
      state.currentUserLoading = false
      state.currentUserError = null
      state.currentUser = user
    },
    [FETCHING_USER_ERROR] (state, error) {
      state.currentUserLoading = false
      state.currentUserError = error
      state.currentUser = null
    },
    [UNSET_USER] (state) {
      state.currentUser = null
    }
  },
  actions: {
    async create ({ commit }, data) {
      commit(CREATING_USER)
      try {
        let response = await UsersAPI.create(data)
        commit(CREATING_USER_SUCCESS, response.data)
        return response.data
      } catch (error) {
        commit(CREATING_USER_ERROR, error)
        return null
      }
    },
    async findAll ({ commit }) {
      commit(FETCHING_USERS)
      try {
        let stations = {}
        let response = await UsersAPI.findAll()
        let stationsAll = await StationAPI.findAll()
        stationsAll.data.forEach(el => {
          stations[el.id] = el.name
        })
        commit(FETCHING_USERS_SUCCESS, { users: response.data, stations: stations })
        return response.data
      } catch (error) {
        commit(FETCHING_USERS_ERROR, error)
        return null
      }
    },
    async findOne ({ commit }, id) {
      commit(FETCHING_USER)
      try {
        let response = await UsersAPI.findOne(id)
        commit(FETCHING_USER_SUCCESS, response.data)
        return response.data
      } catch (e) {
        commit(FETCHING_USER_ERROR, e)
        return null
      }
    },
    unsetCurrent ({ commit }) {
      commit(UNSET_USER)
    }
  }
}
